/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function GenerateCarHistoryReportFileRequestFromJSON(json) {
    return GenerateCarHistoryReportFileRequestFromJSONTyped(json, false);
}
export function GenerateCarHistoryReportFileRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reportId': !exists(json, 'reportId') ? undefined : json['reportId'],
        'html': !exists(json, 'html') ? undefined : json['html'],
    };
}
export function GenerateCarHistoryReportFileRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reportId': value.reportId,
        'html': value.html,
    };
}
